import React from 'react'
import { Accordion } from "react-bootstrap";
import { PlusIcon } from "../../../../../styles/img/svg/PlusIcon";
import { UiTable } from '../../../components/common/UiTable';
import UiIncentiveHistoryCard from '../../../components/common/UiIncentiveHistoryCard';
import { UiCol, UiSingleRow } from '../../../components/grid-container/GridContainer';
import { UiContentCol } from '../../../components/common/UiPageElements';
import { UiCardTitle } from '../../../components/common/UiCardTitle';
import { UiSalesChainElement, UiSalesChainElementNoBgWr } from '../../../components/common/UiSalesChainElements';
import Avatar from '../../../../../styles/img/Avatar.png';
// import { UiInput } from '../../../components/form/UiInput';
import { Button, Table } from "react-bootstrap";
import UiTopSelect from '../../../components/form/UiTopSelect';
import { UiTopInputHeading } from '../../../components/common/UiPageElements';
import { UiCheckboxInput,UiInput } from '../../../components/form/UiInput';
import InfoIcon from '../../../../../styles/img/svg/InfoIcon';


export default function TeamMemberTable(props) {

    const TableHeaders = [
       
        { id: 1, th: 'Firt Name' },
        { id: 2, th: 'Last Name' },
        { id: 3, th: 'Role' },
        { id: 4, th: 'Mobile' },
        { id: 5, th: 'Email' },
        { id: 6, th: 'Active' },
        
    ];

    return (
        <>
            <div className="sb-accordion-wrapper sb-accordion-league-table">
                <Accordion>
                    <Accordion.Item eventKey="0" key="0">
                        <div className="d-flex">

                            <UiCol lg="12" className={props.className}>
                                <UiContentCol>
                                    <Accordion.Header>
                                        <div className='sb-league-tabl-sec__header'>
                                            <h4>Manager's Dashboard</h4>
                                        </div>
                                        <span className="sb-accordion-wrapper__plus"><PlusIcon /></span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <UiSingleRow>
                                            
                                           
                                            <UiCol lg="6" className="sb-league-table-top-heading mb-3">
                                               <h5>Your Team</h5> 
                                            </UiCol>

                                            <UiCol lg="2" className="sb-league-table-top-heading sb-team-table-top-btn mb-3 offset-lg-3">
                                                <Button className="sb-primary-btn--38">500,000 Points</Button>
                                            </UiCol>
                                            <UiCol lg="7">
                                                <div className='sb-league-tabl-sec__incentive-joined-sec'>
                                                    <UiTable className="sb-white-bg-table sb-team-table sb-league-table-individual" tableHeader={TableHeaders}>
                                                        <tr>
                                                          
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>                                
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <h4>Simmons</h4>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <h4>E002000</h4>
                                                                </div>
                                                            </td>
                                                            <td >
                                                                <h4>Technicans</h4>                                              
                                                            </td>
                                                            <td >
                                                               <UiCheckboxInput type="radio"/>
                                                            </td>
                                                           
                                                        </tr>

                                                        <tr>
                                                          
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>                                                                   
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <h4>E002000</h4>
                                                                </div>
                                                            </td>
                                                            <td >
                                                            <h4>Technicans</h4>   
                                                                
                                                            </td>
                                                            <td >
                                                                <UiCheckboxInput type="radio"/>
                                                            </td>
                                                           
                                                        </tr>

                                                        <tr>
                                                          
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>                                                                   
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <h4>E002000</h4>
                                                                </div>
                                                            </td>
                                                            <td >
                                                            <h4>Technicans</h4>   
                                                                
                                                            </td>
                                                            <td >
                                                                <UiCheckboxInput type="radio"/>
                                                            </td>
                                                          
                                                        </tr>

                                                        <tr>
                                                            
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>                                                     
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <h4>E002000</h4>
                                                                </div>
                                                            </td>
                                                            <td >
                                                            <h4>Technicans</h4>   
                                                                
                                                            </td>
                                                            <td >
                                                                <UiCheckboxInput type="radio"/>
                                                            </td>
                                                           
                                                        </tr>

                                                        <tr>
                                                           
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>
                                                                        
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <h4>E002000</h4>
                                                                </div>
                                                            </td>
                                                            <td >
                                                            <h4>Technicans</h4>   
                                                                
                                                            </td>
                                                            <td >
                                                                <UiCheckboxInput type="radio"/>
                                                            </td>
                                                          
                                                        </tr>

                                                      

                                                    </UiTable>
                                                </div>
                                            </UiCol>
                                            <UiCol lg="5" className="sb-team-table-right">
                                                
                                                    {/* <div className='sb-team-table-right__content'>
                                                        <div className='sb-incentive-info-icon'>
                                                            <InfoIcon/>
                                                        </div>
                                                        <h5>This person will not have access to this campaign</h5>
                                                   </div> */}
                                                   <div className='sb-team-table-right__content-details'>
                                                       
                                                        <div className='sb-team-table-right__column-heading'>
                                                            <h4>DRAW DOWN REWARD</h4>
                                                        </div>
                                                        <div className='sb-team-table-right__column'>
                                                            <span>000000000000</span>
                                                        </div>
                                                        <div className='sb-team-table-right__column'>
                                                            <span>000000000000</span>
                                                        </div>
                                                        <div className='sb-team-table-right__column'>
                                                            <span>000000000000</span>
                                                        </div>
                                                        <div className='sb-team-table-right__column'>
                                                            <span>000000000000</span>
                                                        </div>
                                                        <div className='sb-team-table-right__column'>
                                                            <span>000000000000</span>
                                                        </div>
                                                   </div>
                                                   <div className='sb-team-table-banded-text-content'>
                                                        <span>Please ensure only active team members are registered for this incentive by selecting the 'Active' panel in this Team Table.</span>
                                                        <p>We will report your Team's points earning progress throughout the campaign and you will be required to allocate points in accordance with achievements at campaign close.</p>
                                                        <p> Points will then be made automatically available to team members within their Points Bank.</p>
                                                   </div>
                                                
                                            </UiCol>
                                        </UiSingleRow>
                                        <UiSingleRow>
                                            <UiCol lg="3" className="sb-league-table-top-heading sb-banded-btn-bottom mb-3 offset-lg-4">
                                                <Button className="sb-primary-btn--38">Cancel</Button>
                                                <Button className="sb-primary-btn--38">Save</Button>
                                            </UiCol>
                                            <UiCol lg="2" className="sb-league-table-top-heading mb-3 ms-lg-5">
                                                <Button className="sb-primary-btn--38">Allocate Points</Button>
                                            </UiCol>
                                        </UiSingleRow>
                                    </Accordion.Body>
                                </UiContentCol>
                            </UiCol>
                        </div>
                    </Accordion.Item>

                </Accordion>
            </div>

        </>
    )
}
